import { AxiosResponse } from 'axios';

/** Parses HTML document and extracts CSRF middleware token */
const extractCsrfToken = (response: AxiosResponse): null | string => {
  const { data } = response;
  const htmlMarkup = data.split('<');
  const [csrfMiddlewareTokenElement] = htmlMarkup.filter((i: string) => i.includes('csrfmiddlewaretoken'));
  const csrfMiddlewareTokenElementAttributes = csrfMiddlewareTokenElement.split('"');
  const csrfMiddlewareToken = csrfMiddlewareTokenElementAttributes[5];
  if (!csrfMiddlewareToken) return null;
  return csrfMiddlewareToken;
};

const extractUsername = (response: AxiosResponse): string => {
  const { data } = response;
  const htmlMarkup = data.split('<');
  const [usernameElement] = htmlMarkup.filter((i: string) => i.includes('strong>'));
  const username = usernameElement.replace('strong>', '');
  if (!username) throw new Error('Cannot retrieve username for password reset form');
  return username;
};

const resetMapper = { extractCsrfToken, extractUsername };

export default resetMapper;